var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"dense":"","headers":[
    { text: 'Code', value: 'code' },
    { text: 'Tower', value: 'tower.name' },
    { text: 'Floor', value: 'floor.name' }
  ],"sort-by":"code","items":_vm.inventory,"items-per-page":10},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('span',{staticClass:"text-h6 grey--text"},[_vm._v(" Propiedades ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }